import { render } from "./Collapsable.vue?vue&type=template&id=a41d525c&scoped=true"
import script from "./Collapsable.vue?vue&type=script&lang=js"
export * from "./Collapsable.vue?vue&type=script&lang=js"

import "./Collapsable.vue?vue&type=style&index=0&id=a41d525c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41d525c"]])

export default __exports__